import React, { FC } from 'react';

import { useUrlBuilder } from 'hooks/useUrlBuilder';

import { warningInsideBubble, warningHref } from './content/WarningInsideBubble';

export const style = {
  height: '25px',
  width: '25px',
};

/* Components */
export const DisplayerIcon: FC<{}> = () => {
  const { withCDN } = useUrlBuilder();
  return (
    <img
      alt={`${warningInsideBubble} For more information go to ${warningHref}.`}
      src={withCDN('mkt/icon/info_icon_white.png')}
      style={style}
    />
  );
};
